import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';
import {
  Collapse,
  useCollapseState,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { getAdExtensionsSections } from './get-ad-extensions-section';

export const EnhanceYourAdsSection = ({
  suggestedObjectiveExtensions,
  adExtensionsAssociationsFactory,
  adExtensionsDynamicFeatures,
  onUpdateExtensionsAssociations,
  extensionsAssociations,
  campaign,
}) => {
  const i18n = useContext(I18nContext);
  const suggestedAdExtensionsSections = useMemo(() => getAdExtensionsSections({
    extensionTypes: suggestedObjectiveExtensions,
    i18n,
    adExtensionsAssociationsFactory,
    adExtensionsDynamicFeatures,
    onUpdateExtensionsAssociations,
    extensionsAssociations,
    campaign,
  }), [adExtensionsAssociationsFactory, adExtensionsDynamicFeatures, campaign, extensionsAssociations, i18n, onUpdateExtensionsAssociations, suggestedObjectiveExtensions]);

  const [
    allEnhanceYourAdsSections,
    enhanceYourAdsExpandedSections,
    setEnhanceYourAdsExpandedSections,
  ] = useCollapseState(
    suggestedAdExtensionsSections.sectionsInfo.allSections /* all sections */,
    [] /* initially expanded sections */
  );

  const enhanceYourAdsSection = useMemo(() => (
    <>
      {suggestedAdExtensionsSections.panels.length > 0 &&
        <div className={classNames('asset-group-enhance-ads-section')}>
          <h3 className="section-title">{i18n.getString(_TL_('Add more information to your ads'))}</h3>
          <div className="section-description">
            <span>
              <LearnMoreLink
                topic="app54489"
                text={i18n.getString(_TL_('Make your ads larger and more eye-catching by including additional information in your ads.'))}
                linkText={i18n.getString(_TL_('Learn more'))}
              />
            </span>
          </div>
          <Collapse allPanelItems={allEnhanceYourAdsSections} checkItems skipItemsTypeCheck activeKeys={enhanceYourAdsExpandedSections} setActiveKeys={setEnhanceYourAdsExpandedSections}>
            {suggestedAdExtensionsSections.panels}
          </Collapse>
        </div>
      }
    </>
  ), [i18n, allEnhanceYourAdsSections, enhanceYourAdsExpandedSections, setEnhanceYourAdsExpandedSections, suggestedAdExtensionsSections]);

  return enhanceYourAdsSection;
};
